<script lang="ts">
  import { ArrowRight, BarChart3, Briefcase, LineChart, Monitor } from 'lucide-svelte';
  import { push } from 'svelte-spa-router';
  import { auth } from '$lib/stores/auth.svelte';
  import { Button } from '$lib/components/ui/button';
  import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
  } from '$lib/components/ui/card';
  import AppShell from './AppShell.svelte';

  // Las 4 tabs del dashboard, todas operativas en prod.
  const cards = [
    {
      title: 'Sessions',
      desc: 'Full listing with filters (status, account kind, active-now), server-side pagination and Portfolio Overview with equity curve.',
      href: '/sessions',
      icon: Briefcase,
    },
    {
      title: 'Live Monitor',
      desc: 'Live sessions with price ticker, equity sparkline and aggregate bar. Auto-refresh every minute.',
      href: '/live',
      icon: Monitor,
    },
    {
      title: 'Developer Monitor',
      desc: 'Same flow as Live Monitor but filtered to sessions with developerMonitor=true.',
      href: '/developer',
      icon: BarChart3,
    },
    {
      title: 'Charts',
      desc: 'Candlestick + Renko side-by-side with trade markers, fullscreen, Heikin Ashi and Parity Check + Warmup Parity integrated.',
      href: '/charts',
      icon: LineChart,
    },
  ];
</script>

<AppShell>
  <section class="mx-auto w-full max-w-[1280px] px-6 py-12 md:px-10 md:py-16">
    <!-- Hero header: eyebrow + serif display name + subtitle. WSJ/Bloomberg feel. -->
    <header class="mb-12 flex flex-col gap-2">
      <span class="text-eyebrow">Welcome back</span>
      <h1 class="text-display text-foreground text-4xl md:text-5xl">
        {auth.user?.name ?? 'Trader'}
      </h1>
      <p class="text-muted-foreground mt-1 max-w-xl text-[15px] leading-relaxed">
        Read-only view over the live bot's Atlas cluster. Real-time sessions, parity checks and full chart analysis.
      </p>
    </header>

    <!-- 4 cards en grid generoso: padding 32px, min-height para respirar,
         hover con halo primario suave (no flat surface step). -->
    <div class="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
      {#each cards as card (card.href)}
        <Card
          class="group hover:shadow-luxury-primary hover:border-primary/40 relative flex min-h-[280px] flex-col transition-all duration-300"
        >
          <CardHeader class="p-7 pb-4">
            <div
              class="bg-primary/12 text-primary group-hover:bg-primary/18 flex size-12 items-center justify-center rounded-lg transition-colors"
            >
              <card.icon class="size-6" />
            </div>
            <CardTitle class="mt-4 text-xl">{card.title}</CardTitle>
            <CardDescription class="mt-2">{card.desc}</CardDescription>
          </CardHeader>
          <CardContent class="mt-auto p-7 pt-0">
            <Button
              variant="ghost"
              size="sm"
              onclick={() => push(card.href)}
              class="text-primary hover:text-primary -mx-2 w-full justify-between px-2 group-hover:bg-transparent"
            >
              Open
              <ArrowRight class="size-4 transition-transform group-hover:translate-x-0.5" />
            </Button>
          </CardContent>
        </Card>
      {/each}
    </div>
  </section>
</AppShell>
